// The name an event carries in the events table. The engine names an event after the term or cost
// it settles; the business reads the table by its own names for those movements, so the table
// swaps the engine's name for theirs and keeps the share after it. An event with no name here
// keeps the engine's. Prepayment and Balance are terms of both the buyer and the supplier, so a
// name is looked up under the event's category.

import { toPercent } from './inputs.js';

const TABLE_NAMES = {
  BUYER: {
    Prepayment: 'Buyer Payment 1',
    'After loading & inspection': 'Buyer Payment 2',
    'On arrival': 'Buyer Final Payment',
  },
  SUPPLIER: {
    Prepayment: 'Supplier Payment 1',
    Balance: 'Supplier Payment 2',
  },
  COST: {
    'Export clearance charge': 'Export Clearance',
    'Road freight to warehouse — Advance': 'Clearance & Trucking - AGL Payment 1',
    'Road freight to warehouse — Balance on arrival': 'Clearance & Trucking - AGL Payment 2',
    'Warehouse handling in & out': 'Warehousing Handling cost',
    'AGL bonded storage': 'Warehousing cost',
    'DRC import cost': 'DRC Import Costs',
  },
  COMMISSION: {
    'Commission on On arrival': 'Partner Profit Share',
  },
};

// A share is shown when the event pays one part of a whole.
const WHOLE = '1';

export const eventName = (e) => {
  const name = TABLE_NAMES[e.category]?.[e.label] ?? e.label;
  return e.share != null && Number(e.share) !== Number(WHOLE)
    ? `${name} - ${toPercent(e.share)}%`
    : name;
};
